import { getAxiosInstance } from '../../configs/axios-config';
import { authDetails } from '../../helpers/auth-details';
var constants = require("../../configs/constants");
const ADD_MEMBER_PROGRESS = "ADD_MEMBER_PROGRESS";
const ADD_MEMBER_SUCCESS = "ADD_MEMBER_SUCCESS";
const ADD_MEMBER_FAILURE = "ADD_MEMBER_FAILURE";
const SEND_SO_MEMBER_CASE = "SEND_SO_MEMBER_CASE";
const FETCH_MEMBER_PROFILE_SUCCESS = "FETCH_MEMBER_PROFILE_SUCCESS";
const FETCH_MEMBER_PROFILE_FAILURE = "FETCH_MEMBER_PROFILE_FAILURE";
const ADD_MEMBER_PHOTO_SUCCESS = "ADD_MEMBER_PHOTO_SUCCESS";
const DELETE_MEMBER_MODAL = "DELETE_MEMBER_MODAL";
const DELETE_MEMBER_SUCCESS = "DELETE_MEMBER_SUCCESS";
const ADD_SATABARA_PHOTO_SUCCESS = "ADD_SATABARA_PHOTO_SUCCESS";
const ADD_EIGHTA_PHOTO_SUCCESS = "ADD_EIGHTA_PHOTO_SUCCESS";
const HIDE_DMSG_SNACKBAR = "HIDE_DMSG_SNACKBAR";
const LOADING_MEMBER_PHOTO_IN_PROGRESS = "LOADING_MEMBER_PHOTO_IN_PROGRESS";
const LOADING_SATABARA_IN_PROGRESS = "LOADING_SATABARA_IN_PROGRESS";
const LOADING_EIGHTA_IN_PROGRESS = "LOADING_EIGHTA_IN_PROGRESS";

export const hideSnackBarAction = () => { return { type: HIDE_DMSG_SNACKBAR } }
export const loadingOneInProgress = () => { return { type: LOADING_MEMBER_PHOTO_IN_PROGRESS } }
export const loadingTwoInProgress = () => { return { type: LOADING_SATABARA_IN_PROGRESS } }
export const loadingThreeInProgress = () => { return { type: LOADING_EIGHTA_IN_PROGRESS } }
export const addProfileInProgress = (profileData) => { return { type: ADD_MEMBER_PROGRESS, profileData: profileData } }
export const addProfileSuccess = (successMessage) => { return { type: ADD_MEMBER_SUCCESS, message: successMessage } }
export const addProfileFailure = (errorMessage) => { return { type: ADD_MEMBER_FAILURE, message: errorMessage } }
export const fetchProfileDetailsSuccess = (data) => { return { type: FETCH_MEMBER_PROFILE_SUCCESS, data: data } }
export const fetchProfileDetailsFailure = (errorMessage) => { return { type: FETCH_MEMBER_PROFILE_FAILURE, message: errorMessage } }
export const returnProfile = (caseData, edit, profileDetails) => { return { type: SEND_SO_MEMBER_CASE, caseData: caseData, edit: edit, profileDetails: profileDetails } }
export const addMemberPhotoSuccess = (photoUrlOne, successMsg) => { return { type: ADD_MEMBER_PHOTO_SUCCESS, photoUrlOne: photoUrlOne, successMsg: successMsg } }
export const addSataBaraPhotoSuccess = (photoUrlTwo, successMsg) => { return { type: ADD_SATABARA_PHOTO_SUCCESS, photoUrlTwo: photoUrlTwo, successMsg: successMsg } }
export const addEightAPhotoSuccess = (photoUrlThree, successMsg) => { return { type: ADD_EIGHTA_PHOTO_SUCCESS, photoUrlThree: photoUrlThree, successMsg: successMsg } }
export const editProfileSuccess = (successMessage) => { return { type: ADD_MEMBER_SUCCESS, message: successMessage } }
export const editProfileFailure = (errorMessage) => { return { type: ADD_MEMBER_FAILURE, message: errorMessage } }
export const deleteProfileSuccess = (successMessage) => { return { type: DELETE_MEMBER_SUCCESS, message: successMessage } }
export const deleteProfileFailure = (errorMessage) => { return { type: DELETE_MEMBER_SUCCESS, message: errorMessage } }
export const returnDeleteUserModal = (deleteCase, deletedId) => { return { type: DELETE_MEMBER_MODAL, deleteCase: deleteCase, deletedId: deletedId } }

/**
* render the delete user modal 
* @param {boolen & object}, true, delete user id
*/
export const showDeleteModal = (deleteCase, deletedId) => (dispatch) => {
    dispatch(returnDeleteUserModal(deleteCase, deletedId));
};

// RENDER COMPONENT USING SWITCH CASE
export const renderProfile = (caseData, edit, profileDetails) => (dispatch) => {
    dispatch(returnProfile(caseData, edit, profileDetails));
};

// HIDE THE MESSAGE SNACKBAR
export const hideSnackBar = () => (dispatch) => {
    dispatch(hideSnackBarAction());
}

// POST MEMBER PROFILE PHOTO
export const uploadFile = (memberPhoto) => (dispatch) => {
    dispatch(loadingOneInProgress());
    let bodyFormData = new FormData();
    bodyFormData.append('file', memberPhoto.memberPhoto);
    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    }
    let axiosInstance = getAxiosInstance();
    return axiosInstance.post(constants.api.UPLOAD, bodyFormData, config
    ).then(function (response) {
        dispatch(addMemberPhotoSuccess(response.data.secureUrl, "प्रोफाइल फोटो यशस्वीरित्या अपलोड केला आहे"));
    }).catch(function (error) {
        dispatch(addProfileFailure(error.message));
    });
};

// POST MEMBER SATBARA PHOTO
export const uploadFileTwo = (sataBaraPhoto) => (dispatch) => {
    dispatch(loadingTwoInProgress());
    let bodyFormData = new FormData();
    bodyFormData.append('file', sataBaraPhoto.sataBaraPhoto);
    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    }

    let axiosInstance = getAxiosInstance();

    return axiosInstance.post(constants.api.UPLOAD_FILES, bodyFormData, config
    ).then(function (response) {
        dispatch(addSataBaraPhotoSuccess(response.data.secureUrl, "सातबारा अपलोड केला आहे"));
    }).catch(function (error) {
        dispatch(addProfileFailure(error.message));
    });
};

// POST MEMBER 8A PHOTO
export const uploadFileThree = (eightAPhoto) => (dispatch) => {
    dispatch(loadingThreeInProgress());
    let bodyFormData = new FormData();
    bodyFormData.append('file', eightAPhoto.eightAPhoto);
    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    }

    let axiosInstance = getAxiosInstance();
    return axiosInstance.post(constants.api.UPLOAD_FILES, bodyFormData, config
    ).then(function (response) {
        dispatch(addEightAPhotoSuccess(response.data.secureUrl, "८ अ अपलोड केला आहे"));
    }).catch(function (error) {
        dispatch(addProfileFailure(error.message));
    });
};

// GET MEMBER PROFILE 
export const fetchProfiles = (data) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    return axiosInstance.get(constants.api.GET_SO_MEMBER_PROFILE + user._id + '/' + data.perpage + '/' + data.page, {
    }).then(function (response) {
        dispatch(fetchProfileDetailsSuccess(response.data));
    }).catch(function (error) {
        dispatch(fetchProfileDetailsFailure(error.message));
    });
};

// Search Member by name
export const searchMember = (name) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    return axiosInstance.get(constants.api.SEARCH_MEMBER, {
        params: { societyId: user._id, name: name, perpage: '5', page: '1' }
    }).then(function (response) {
        dispatch(fetchProfileDetailsSuccess(response.data));
    }).catch(function (error) {
        dispatch(fetchProfileDetailsFailure(error.message));
    });
};

// POST MEMBER PROFILE DETAILS
export const addProfile = (profileData) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();

    dispatch(addProfileInProgress(profileData));
    return axiosInstance.post(constants.api.SO_MEMBER, {
        fullName: profileData.allData.fullName,
        address: profileData.allData.address,
        mobileNumber1: profileData.allData.mobileNumber1,
        mobileNumber2: profileData.allData.mobileNumber2,
        adharNo: profileData.allData.adharNo,
        village: profileData.allData.village,
        taluka: profileData.allData.taluka,
        state: profileData.allData.state,
        district: profileData.allData.district,
        pincode: profileData.allData.pincode,
        gender: profileData.allData.gender,
        membershipDate: profileData.allData.membershipDate,
        memberPhoto: profileData.memberPhoto,
        addedBy: user._id,
    }).then(function (response) {
        dispatch(addProfileSuccess(response.data.message));
        fetchProfiles(dispatch);
    }).catch(function (error) {
        dispatch(addProfileFailure(error.response.data.message));
    });
};

// EDIT MEMBER PROFILE DETAILS
export const editProfile = (profileData) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();

    return axiosInstance.put(constants.api.SO_MEMBER, {
        fullName: profileData.fullName,
        address: profileData.address,
        mobileNumber1: profileData.mobileNumber1,
        mobileNumber2: profileData.mobileNumber2,
        adharNo: profileData.adharNo,
        village: profileData.village,
        taluka: profileData.taluka,
        state: profileData.state,
        district: profileData.district,
        pincode: profileData.pincode,
        gender: profileData.gender,
        membershipDate: profileData.membershipDate,
        memberPhoto: profileData.memberPhoto,
        memberId: profileData.memberId,
        addedBy: user._id,
    }).then(function (response) {
        dispatch(editProfileSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(editProfileFailure(error.response.data.message));
    });
};

// DELETE MEMBER DETAILS
export const deleteMember = (memberId) => (dispatch) => {
    let axiosInstance = getAxiosInstance();

    return axiosInstance.patch(constants.api.SO_MEMBER + '/' + memberId).then(function (response) {
        dispatch(deleteProfileSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(deleteProfileFailure(error.message));
    });
};

export const initialState = {
    choice: 'table',
    profileDetails: '',
    message: '',
    profileData: [],
    photoUrlOne: '',
    photoUrlTwo: '',
    photoUrlThree: '',
    inProgress: false,
    open: false,
    edit: false,
    add: false,
    delete: false,
    deletedId: '',
    deleteCase: false,
    loadingOne: false,
    loadingTwo: false,
    loadingThree: false,
    totalRowsCount: 0
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_MEMBER_PROGRESS:
            return { ...state, inProgress: true };
        case ADD_MEMBER_SUCCESS:
            return { ...state, message: action.message, inProgress: false, open: true, choice: 'table', add: true, photoUrlOne: '', photoUrlThree: '', photoUrlTwo: '' };
        case ADD_MEMBER_FAILURE:
            return { ...state, message: action.message, inProgress: false, loadingThree: false, loadingOne: false, loadingTwo: false };
        case FETCH_MEMBER_PROFILE_SUCCESS:
            return { ...state, profileData: action.data.dataList, totalRowsCount: action.data.totalItems, add: false, delete: false };
        case FETCH_MEMBER_PROFILE_FAILURE:
            return { ...state };
        case DELETE_MEMBER_MODAL:
            return { ...state, deletedId: action.deletedId, deleteCase: action.deleteCase };
        case DELETE_MEMBER_SUCCESS:
            return { ...state, message: action.message, open: true, deleteCase: false, delete: true };
        case LOADING_MEMBER_PHOTO_IN_PROGRESS:
            return { ...state, loadingOne: true };
        case ADD_MEMBER_PHOTO_SUCCESS:
            return { ...state, photoUrlOne: action.photoUrlOne, message: action.successMsg, open: true, loadingOne: false };
        case LOADING_SATABARA_IN_PROGRESS:
            return { ...state, loadingTwo: true };
        case ADD_SATABARA_PHOTO_SUCCESS:
            return { ...state, photoUrlTwo: action.photoUrlTwo, message: action.successMsg, open: true, loadingTwo: false };
        case LOADING_EIGHTA_IN_PROGRESS:
            return { ...state, loadingThree: true };
        case ADD_EIGHTA_PHOTO_SUCCESS:
            return { ...state, photoUrlThree: action.photoUrlThree, message: action.successMsg, open: true, loadingThree: false };
        case SEND_SO_MEMBER_CASE:
            return { ...state, profileDetails: action.profileDetails, edit: action.edit, choice: action.caseData };
        case HIDE_DMSG_SNACKBAR:
            return { ...state, open: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/society/so-member-reducer.js